import { Component, input } from '@angular/core';

import { DetailedQuote } from '../../../../../domain/quote.domain';
import { IconFlagComponent } from '../../../../../components/icon/icon-flag.component';
import { CurrencyPipe } from '../../../../../pipes/currency.pipe';
import { TodaysChangeComponent } from '../../todays-change/todays-change.component';
import { QuoteIssueType } from '../../domain';

@Component({
  selector: 'td-wb-detailed-quote-summary-symbol-detail',
  templateUrl: './detailed-quote-summary-symbol-detail.component.html',
  styleUrls: ['./detailed-quote-summary-symbol-detail.component.scss'],
  imports: [
    IconFlagComponent,
    CurrencyPipe,
    TodaysChangeComponent
  ],
  host: {
    '[attr.role]': 'role'
  }
})
export class DetailedQuoteSummarySymbolDetailComponent {

  readonly quote = input<DetailedQuote>(undefined);
  readonly displayName = input<boolean>(true);
  readonly role: string = 'listitem';
  isMutualFund(): boolean {
    return this.quote().issueType === QuoteIssueType.MF;
  }

}
